const LoadState = {
    NotLoaded: 'NotLoaded',
    Loading: 'Loading',
    Loaded: 'Loaded',
    Idle: 'Idle',
    Failed: 'Failed',
};
export default LoadState;
